import { SVGProps, Ref, forwardRef } from "react";

const SubtractIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 24 24"
    fill="none"
    width="1em"
    height="1em"
    ref={ref}
    aria-label="Add Icon"
    {...props}
  >
    <title id="Add Icon">Add Icon</title>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M 6,12 L 18,12"
    />
  </svg>
);

const ForwardRef = forwardRef(SubtractIcon);
export default ForwardRef;
